import { render, staticRenderFns } from "./myProgramPackBookPage.vue?vue&type=template&id=4c5d8528&scoped=true&"
import script from "./myProgramPackBookPage.vue?vue&type=script&lang=ts&"
export * from "./myProgramPackBookPage.vue?vue&type=script&lang=ts&"
import style0 from "./programPackBook.css?vue&type=style&index=0&id=4c5d8528&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d8528",
  null
  
)

export default component.exports